import { ComponentRegistry } from '@sg-core/resources/assets/js/libs/component-registry';

export class IwcComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/iwc/src/View/Components/**/*.ts');
  }
}
